<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <div class="text-xs-right">
          <v-btn flat color="grey" @click="toggleView()">
            <v-icon left v-if="listView">list</v-icon>
            <v-icon left v-else>view_module</v-icon>View
          </v-btn>
        </div>
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Sort by..."
            :items="sortFactors"
            v-model="sortBy"
            prepend-icon="sort"
            :disabled="listView"
            dense
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Type"
            :items="['Active', 'Inactive', 'Request']"
            v-model="selectedRecordType"
          ></v-select>
        </v-flex>
      </layout-no-padding>

      <v-dialog
        v-model="addContractorDialog"
        max-width="500px"
        @keydown.esc="addContractorDialog = false"
      >
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-contractor" slot="activator">
          <v-icon dark>{{ isRequest ? 'post_add' : 'add' }}</v-icon>
        </v-btn>
        <!-- ADD DRIVER COMPONENT-->
        <add-contractor @close="addContractorDialog = false" :isRequest="isRequest"></add-contractor>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import ContractorValidation from '@/services/validation/contractorValidation'
import AddContractor from '@/components/contractors/addContractor'
import RouteProps from '@/services/mixins/routeProps'

//GET RECORDS
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'
export default {
  mixins: [ContractorValidation, RouteProps, getContractors, getProjects],
  data() {
    return {
      includeInactive: true,
      addContractorDialog: false,
      sortFactors: [
        {
          value: 'id',
          text: 'ID',
        },
        {
          value: 'name',
          text: 'Name',
        },
        {
          value: 'updatedAt',
          text: 'Updated At',
        },
      ],
    }
  },
  methods: {
    toggleView() {
      this.listView = !this.listView
    },
    sortContractors(path1, path2) {
      return this.contractors.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1
        } else {
          return 1
        }
      })
    },
  },
  computed: {
    sortBy: Store.getSet({ store: 'contractors', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'contractors', prop: 'filterBy' }),
    listView: Store.getSet({ store: 'contractors', prop: 'listView' }),
    showInactive: Store.getSet({ store: 'contractors', prop: 'showInactive' }),
    selectedRecordType: Store.getSet({
      store: 'contractors',
      prop: 'selectedRecordType',
    }),
    isRequest() {
      return this.$store.state.user.userAuthClass.name !== 'Administrator'
    },
  },
  components: {
    AddContractor,
  },
}
</script>

<style scoped>
.overlap-fab-contractor {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>

